import React from "react";

import { CategoryBarChart } from "../charts/CategoryBarChart";
import { ChartLayout, formatterFromTickformat, layoutHeight, layoutWidth } from "../charts/chartTheme";

interface ISustainableDevelopmentGoalsProps {
    sustainableDevelopmentGoals: any;
    totalExposure: number;
    layout?: ChartLayout;
    style?: React.CSSProperties | undefined;
}

const SustainableDevelopmentGoalUrls = {
    Goal1_NoPoverty: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_1",
    Goal2_ZeroHunger: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_2",
    Goal3_GoodHealthAndWellBeing: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_3",
    Goal4_QualityEducation: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_4",
    Goal5_GenderEquality: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_5",
    Goal6_CleanWaterAndSanitation: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_6",
    Goal7_AffordableAndCleanEnergy: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_7",
    Goal8_DecentWorkAndEconomicGrowth: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_8",
    Goal9_IndustryInnovationAndInfrastructure: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_9",
    Goal10_ReducedInequality: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_10",
    Goal11_SustainableCitiesAndCommunities: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_11",
    Goal12_ResponsibleConsumptionAndProduction: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_12",
    Goal13_ClimateAction: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_13",
    Goal14_LifeBelowWater: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_14",
    Goal15_LifeOnLand: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_15",
    Goal16_PeaceJusticeAndStrongInstitutions: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_16",
    Goal17_PartnershipsToAchieveTheGoal: "https://en.wikipedia.org/wiki/Sustainable_Development_Goal_17"
};

const GOAL_COLORS = [
    "#e5243b",
    "#DDA63A",
    "#4C9F38",
    "#C5192D",
    "#FF3A21",
    "#26BDE2",
    "#FCC30B",
    "#A21942",
    "#FD6925",
    "#DD1367",
    "#FD9D24",
    "#BF8B2E",
    "#3F7E44",
    "#0A97D9",
    "#56C02B",
    "#00689D",
    "#19486A"
];

export const SustainableDevelopmentGoals = ({
    sustainableDevelopmentGoals,
    totalExposure,
    layout,
    style
}: ISustainableDevelopmentGoalsProps): React.ReactElement => {
    const labels = Object.keys(sustainableDevelopmentGoals ?? {});
    const coloredRows = labels.map((label) => ({
        category: label,
        series: label,
        value: totalExposure ? Number(sustainableDevelopmentGoals[label]) / totalExposure : 0
    }));

    return (
        <div>
            <h3>Sustainable Development Goals</h3>
            <CategoryBarChart
                rows={coloredRows}
                orientation="horizontal"
                colors={GOAL_COLORS}
                showLegend={layout?.showlegend ?? false}
                valueFormat={formatterFromTickformat(".0%")}
                ariaLabel="Sustainable Development Goals"
                height={layoutHeight(layout, 250)}
                width={layoutWidth(layout) ?? 460}
                style={style}
                onSelect={(category) => {
                    const url = SustainableDevelopmentGoalUrls[category];
                    if (url) {
                        const win = window.open(url, "_blank");
                        win?.focus();
                    }
                }}
            />
        </div>
    );
};
